/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Enum for network status currently only used with the Native Bindings
 * so this has been migrated from AssetContext to help avoid importing
 * AssetContext directly instead of by type.
 *
 * @note Must be kept in sync with NetworkStatus in AssetContext.h
 */
export var NetworkStatus;
(function (NetworkStatus) {
    NetworkStatus[NetworkStatus["Offline"] = 0] = "Offline";
    NetworkStatus[NetworkStatus["Wan"] = 1] = "Wan";
    NetworkStatus[NetworkStatus["Cellular"] = 2] = "Cellular";
    NetworkStatus[NetworkStatus["OnlineUnknown"] = 3] = "OnlineUnknown";
})(NetworkStatus || (NetworkStatus = {}));
